import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from '../reducers/gbp.reducer';

const getState = createFeatureSelector<fromReducer.GBPState>(
    fromReducer.featureKey
);

const getPageState = createSelector(getState, (state) => state);

export const getIsLoading = createSelector(getPageState, fromReducer.isLoading);
export const getSucceeded = createSelector(getPageState, fromReducer.succeeded);
export const getHasError = createSelector(getPageState, fromReducer.hasError);
export const getErrorMessage = createSelector(getPageState, fromReducer.errorMessage);
export const getGBPData = createSelector(getPageState, fromReducer.gbpData);

